import { ScrollReveal } from "@/hooks/useScrollReveal";
import { SONGBO_URL, CATALOG_URL } from "@/mocks/site-config";

export default function SonboRelation() {
  return (
    <section className="min-h-[100svh] flex items-center bg-background-100 relative z-[2]">
      <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:gap-16 mb-14 md:mb-20">
            <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
              <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                Brand Matrix
              </p>
            </div>
            <div className="lg:w-[70%]">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                崧博出版品牌矩陣
              </h2>
              <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
                崧燁文化委託崧博出版進行書籍經銷，官方網站由崧博出版製作。崧博出版主站提供完整的出版服務說明，正式書目則可前往崧博出版書籍資料庫查詢。
              </p>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={150}>
          <div className="lg:ml-[30%] lg:pl-16">
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={SONGBO_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-foreground-900 hover:bg-foreground-800 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground-400 focus-visible:ring-offset-2"
              >
                認識崧博出版 <i className="ri-external-link-line text-sm"></i>
              </a>
              <a
                href={CATALOG_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-secondary-500 hover:bg-secondary-600 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-400 focus-visible:ring-offset-2"
              >
                前往書籍資料庫 <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}